
import { Vue } from 'vue-class-component';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';
import ErrorCode from '@/constants/ErrorCode';
import * as countryAreaCode from '@/assets/data/countryAreaCode.json';
import Status from '@/constants/Status';
import UserInfoService from '@/services/userInfoService';
import UpdateUserInfoModel from '@/models/userInfos/updateUserInfoModel';
import UserInfoModel from '@/models/userInfos/UserInfoModel';
import RoleService from '@/services/roleService';
import CommonValidate from '@/services/commonValidate';
import CurrentUserService from '@/services/currentUserService';
import AccountType from '@/constants/AccountType';

export default class UserInfoDetail extends Vue {
  private model: UpdateUserInfoModel = new UpdateUserInfoModel();

  private countryAreaCodes = (countryAreaCode as any).default;

  private roleList=[];

  private userId='';

  private userInfo:UserInfoModel =new UserInfoModel();

  private rules = {
    nickName: [{
      required: true, whitespace: true, message: '请输入账号昵称', trigger: 'blur',
    }, { validator: CommonValidate.validateNickName, trigger: 'blur' }],
    accessGroup: [
      { required: true, message: '请选择角色', trigger: 'change' },
    ],
    phoneNo: [{
      required: true, whitespace: true, message: '请输入手机号码', trigger: 'blur',
    }, { validator: CommonValidate.validatePhone, trigger: 'blur' }],
  };

  mounted(): void {
    this.userId = this.$route.params.id as string;
    this.loadRole();
    this.loadData();
  }

  loadRole(): void {
    const currentAccountType = CurrentUserService.userInfo.accountType;
    const accountType = currentAccountType === AccountType.PlateAccount || currentAccountType === AccountType.PlateSubAccount ? AccountType.PlateSubAccount : AccountType.CustomerSubAccount;
    RoleService.getAll().then((result) => {
      if (result.code === ErrorCode.Success) {
        this.roleList = result.data.filter((it:any) => it.accountType === accountType);
      }
    }).catch((err) => {
      if (err) {
        console.log(err);
        ElMessage.error(err.msg);
      }
    });
  }

  loadData(): void {
    UserInfoService.get(this.userId)
      .then((result) => {
        if (result.code === ErrorCode.Success) {
          this.userInfo = result.data;
          this.model.nickName = result.data.nickName;
          this.model.accessGroup = result.data.accessGroup;
          this.model.remark = result.data.remark;
          this.model.phoneNo = result.data.phoneNo?.split('-')[1] as string;
          this.model.phonePrefix = result.data.phoneNo?.split('-')[0] as string;
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  goBack():void {
    this.$router.back();
  }

  save(): void {
    const updateform: any = this.$refs.form;
    updateform.validate((valid: boolean) => {
      if (valid) {
        const loadingInstance = ElLoading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        UserInfoService.update(this.userId, this.model).then(
          (response) => {
            loadingInstance.close();
            if (response.code === ErrorCode.Success) {
              ElMessage.success(response.msg);
            } else if (response.code === ErrorCode.ParamsterInvalid) {
              ElMessage.error(response.data[0].message);
            } else {
              ElMessage.error(response.msg);
            }
          },
        ).catch((err) => {
          loadingInstance.close();
          console.error(err);
          if (err && err.msg) {
            ElMessage.error(err.msg);
          } else if (err) {
            ElMessage.error(err);
          }
        });
      }
    });
  }

  updateStatus(code:number):void {
    const msg = `你确定要${code === Status.正常 ? '启用' : '禁用'}当前账号?`;
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        UserInfoService.updateStatus(this.userId, code)
          .then((response) => {
            if (response.code === ErrorCode.Success) {
              ElMessage.success(response.msg);
              this.userInfo.status = code;
            } else {
              ElMessage.error(response.msg);
            }
          })
          .catch((response) => {
            ElMessage.error(response.msg);
          });
      });
  }
}
